import { useLocation, } from 'react-router-dom'
import ProjectPageContent from './components/ProjectPageContent/ProjectPageContent'
import ProjectDetailPage from '../ProjectDetailPage/ProjectDetailPage'
import { useEffect, useRef, useState } from 'react'
import { DASHBOARD_CONTENT_CONTAINER_ID } from '@/router/pageConst'
import { observer } from 'mobx-react'
import useProductType from '@/helpers/commonHooks/useProductType'

function ExperienceProjectPage() {
  const location = useLocation()
  const { productType } = useProductType()
  const isDetail = location.state && location.state.id
  const scorllTop = useRef(0)
  const [whichProjectDetail, setWhichProjectDetail] = useState<ProjectModels.ProjectDetail | null>(null)

  useEffect(() => {
    const dashboardContent = document.getElementById(DASHBOARD_CONTENT_CONTAINER_ID)!
    if (isDetail) {
      dashboardContent.scrollTo({ top: 0 })
    } else {
      dashboardContent.scrollTo({ top: scorllTop.current })
    }
    const handleScroll = (e: Event) => {
      if (!isDetail) {
        const target = e.target as HTMLElement
        scorllTop.current = target.scrollTop
      }
    }
    dashboardContent.addEventListener('scroll', handleScroll)
    return () => {
      dashboardContent.removeEventListener('scroll', handleScroll)
    }
  }, [isDetail])

  return (
    <>
      <div style={{ display: isDetail ? 'none' : 'block', opacity: isDetail ? 0 : 1 }}>
        <ProjectPageContent
          key={productType}
          isDetailMode={isDetail}
          whichProjectDetail={whichProjectDetail}
        />
      </div>
      {isDetail && <ProjectDetailPage onProjectDetailUpdate={(project) => {
        setWhichProjectDetail(project)
      }} />}
    </>
  )
}

export default observer(ExperienceProjectPage)
